import { jsxs as O, jsx as a } from "react/jsx-runtime";
import { n as w } from "./emotion-styled.browser.esm.js";
import { B as h } from "./button.js";
import { theme as p } from "../theme/index.js";
import { g as f, M } from "./rootProvider.js";
import { g as k } from "./useScreenSize.js";
import { R as F, a as g } from "./ExclamationCircleFilled.js";
import { T as $ } from "./index3.js";
const z = w.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: ${p.spacing[2]};
  margin-top: ${p.spacing[4]};
`, B = w.div`
  left: 0;
  margin-right: auto;
`, I = (t) => {
  const o = {
    primary: "primary",
    secondary: "secondary"
  };
  return t === "error" && (o.primary = "danger"), o;
}, R = ({
  appearance: t,
  primaryAction: o,
  secondaryAction: e,
  extras: n
}) => {
  const s = I(t), r = {
    appearance: s.primary,
    children: (o == null ? void 0 : o.label) || "Okay",
    ...o
  }, l = {
    variant: "outlined",
    appearance: s.secondary,
    children: (e == null ? void 0 : e.label) || "Cancel",
    ...e
  };
  return /* @__PURE__ */ O(z, { children: [
    n && /* @__PURE__ */ a(B, { children: n }),
    e && /* @__PURE__ */ a(h, { ...l }),
    /* @__PURE__ */ a(h, { ...r })
  ] });
}, T = Object.fromEntries(
  k(p.screens)
), E = {
  success: /* @__PURE__ */ a(F, { style: { color: p.colors.success } }),
  info: /* @__PURE__ */ a(g, { style: { color: p.colors.info } }),
  warning: /* @__PURE__ */ a(g, { style: { color: p.colors.warning } }),
  error: /* @__PURE__ */ a(g, { style: { color: p.colors.error } })
}, d = (t, o = {}) => {
  const {
    appearance: e = "success",
    onClose: n,
    primaryAction: s,
    secondaryAction: r,
    footer: l,
    title: c,
    closable: i = !0,
    centered: u = !0,
    destroyOnClose: y = !0,
    extras: C,
    size: P = "md",
    width: b,
    ...S
  } = t, { defaultCloseAction: x = "secondary" } = o, j = () => {
    i && (n == null || n());
  }, v = () => {
    const m = {
      primaryAction: s,
      secondaryAction: r,
      appearance: e,
      extras: C
    };
    return n && (x === "primary" ? m.primaryAction = {
      onClick: n,
      ...s
    } : m.secondaryAction = {
      onClick: n,
      ...r
    }), l !== void 0 ? typeof l == "function" ? l(m) : l : /* @__PURE__ */ a(R, { ...m });
  }, A = typeof c == "string" ? /* @__PURE__ */ a($.Title, { level: 5, children: c }) : c;
  return {
    ...S,
    icon: E[e],
    title: A,
    onCancel: j,
    footer: v(),
    closable: i,
    centered: u,
    destroyOnHidden: y,
    appearance: "success",
    width: b ?? T[P] * 0.8
  };
}, H = {
  success: ({ content: t, ...o }) => {
    let e = null;
    const n = d(
      {
        ...o,
        onClose: async () => {
          var r;
          const s = await ((r = o.onClose) == null ? void 0 : r.call(o));
          return e == null || e.destroy(), s;
        },
        appearance: "success"
      },
      {
        defaultCloseAction: "primary"
      }
    );
    return e = f.modal.success({ ...n, content: t }), e;
  },
  info: ({ content: t, ...o }) => {
    let e = null;
    const n = d(
      {
        ...o,
        onClose: async () => {
          var r;
          const s = await ((r = o.onClose) == null ? void 0 : r.call(o));
          return e == null || e.destroy(), s;
        },
        appearance: "info"
      },
      {
        defaultCloseAction: "primary"
      }
    );
    return e = f.modal.info({ ...n, content: t }), e;
  },
  warning: ({ content: t, ...o }) => {
    let e = null;
    const n = d(
      {
        ...o,
        onClose: async () => {
          var r;
          const s = await ((r = o.onClose) == null ? void 0 : r.call(o));
          return e == null || e.destroy(), s;
        },
        appearance: "warning"
      },
      {
        defaultCloseAction: "primary"
      }
    );
    return e = f.modal.warning({ ...n, content: t }), e;
  },
  error: ({ content: t, ...o }) => {
    let e = null;
    const n = d(
      {
        ...o,
        onClose: async () => {
          var r;
          const s = await ((r = o.onClose) == null ? void 0 : r.call(o));
          return e == null || e.destroy(), s;
        },
        appearance: "error"
      },
      {
        defaultCloseAction: "primary"
      }
    );
    return e = f.modal.error({ ...n, content: t }), e;
  },
  confirm: ({
    content: t,
    appearance: o,
    ...e
  }) => {
    let n = null;
    const s = new Promise((c) => {
      n = c;
    });
    let r = null;
    const l = d({
      ...e,
      appearance: o,
      onClose: async () => {
        var i;
        const c = await ((i = e.onClose) == null ? void 0 : i.call(e));
        return n(!1), r == null || r.destroy(), c;
      },
      primaryAction: {
        label: "Confirm",
        onClick: async (c) => {
          var u, y;
          const i = await ((y = (u = e.primaryAction) == null ? void 0 : u.onClick) == null ? void 0 : y.call(u, c));
          return n(!0), r == null || r.destroy(), i;
        }
      }
    });
    return r = f.modal.confirm({ ...l, content: t }), Object.assign(s, {
      destroy: r == null ? void 0 : r.destroy,
      update: r == null ? void 0 : r.update
    });
  },
  destroyAll: M.destroyAll
}, J = w(M)``, W = ({ open: t, children: o, style: e, className: n, ...s }) => {
  const r = d({ ...s });
  return /* @__PURE__ */ a(
    J,
    {
      open: t,
      style: e,
      className: n,
      ...r,
      children: o
    }
  );
}, V = Object.assign(W, H);
export {
  V as M
};
